import DeleteIcon from "@mui/icons-material/Delete";
import {
  Box,
  Button,
  Divider,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import React, { useRef, useState } from "react";
import messageIcon from "../../../asset/images/messageIcon.png";
import refreshIcon from "../../../asset/images/refreshIcon.png";

const HistorySidebar = ({
  setSessionActive,
  setMode,
  historyList,
  setOpenDeleteDialog,
  setItemToDelete,
  isMobile = false,
  ...rest
}) => {
  const [itemHovered, setItemHovered] = useState(null);
  const touchStartTimeRef = useRef(null);
  const touchTimerRef = useRef(null);

  const handleTouchStart = (conversation) => {
    touchStartTimeRef.current = Date.now();
    touchTimerRef.current = setTimeout(() => {
      setOpenDeleteDialog(true);
      setItemToDelete(conversation);
    }, 1000);
  };

  const handleTouchEnd = () => {
    if (touchTimerRef.current) {
      clearTimeout(touchTimerRef.current);
    }
  };
  return (
    <Box
      sx={{
        width: "24.5vw",
        height: "70vh",
        position: "fixed",
        left: 0,
        top: "15vh",
        backgroundColor: "#FFFFFF",
        borderRight: "15px solid #FBFBFB",
        padding: "20px",
        ...(isMobile && {
          width: "98vw",
          height: "95vh",
          top: "40px",
          padding: "1px",
          borderRight: "0px solid #FBFBFB",
        }),
      }}
    >
      {!isMobile && <Divider sx={{ margin: "10px 0" }} />}
      <Button
        type="text"
        onClick={() => {
          setSessionActive(null);
          setMode("init");
          let url = new URL(window.location.href);
          url.hash = "";
          url.searchParams.delete("sessionId");
          window.history.pushState({}, "", url);
        }}
        aria-label="New conversation"
        sx={{
          padding: "10px",
          borderRadius: "8px",
          marginLeft: "-10px",
          "&:hover": {
            backgroundColor: "#e0e0e0",
          },
        }}
      >
        <img
          src={refreshIcon}
          alt="New conversation"
          style={{ marginRight: "10px", width: "20px", height: "20px" }}
        />
        <Typography
          variant="body"
          sx={{
            fontFamily: "Montserrat",
            fontSize: "13.96px",
            fontWeight: 400,
            lineHeight: "20.95px",
            textAlign: "left",
            textUnderlinePosition: "from-font",
            textDecorationSkipInk: "none",
            color: "#898989",
            textTransform: "none",
            "&:hover": {
              color: "#555555",
            },
          }}
        >
          Démarrer une nouvelle conversation
        </Typography>
      </Button>

      <Typography
        variant="h6"
        sx={{
          fontFamily: "Montserrat",
          fontSize: "16.53px",
          fontWeight: "500",
          lineHeight: "24.8px",
          textUnderlinePosition: "from-font",
          textDecorationSkipInk: "none",
          marginLeft: "10px",
          marginTop: "10px",
          color: "#000000",
        }}
      >
        Explorer l’historique
      </Typography>
      <Box
        sx={{
          marginTop: "10px",
          marginLeft: "10px",
          overflowY: "auto",
          maxHeight: "55vh",
          ...(isMobile && {
            maxHeight: "90vh",
          }),
        }}
      >
        <List>
          {historyList
            .sort((a, b) => new Date(b.date) - new Date(a.date))
            .map((conversation, index) => (
              <ListItem
                key={index}
                button
                {...(!isMobile && {
                  onMouseEnter: () => {
                    setItemHovered(index);
                  },
                  onMouseLeave: () => {
                    setItemHovered(null);
                  },
                })}
                {...(isMobile && {
                  onTouchStart: () => handleTouchStart(conversation),
                  onTouchEnd: handleTouchEnd,
                })}
                onClick={() => {
                  setSessionActive(conversation.sessionId);
                  setMode("init");
                  let url = new URL(window.location.href);
                  url.searchParams.set("sessionId", conversation.sessionId);
                  window.history.pushState({}, "", url);
                }}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px",
                  borderRadius: "8px",
                  "&:hover": {
                    backgroundColor: "#e0e0e0",
                  },
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={messageIcon}
                    alt="Message Icon"
                    style={{ marginRight: "10px" }}
                  />
                  <Typography
                    variant="body"
                    sx={{
                      fontFamily: "Montserrat",
                      fontSize: "13.96px",
                      fontWeight: 400,
                      lineHeight: "20.95px",
                      textAlign: "left",
                      textUnderlinePosition: "from-font",
                      textDecorationSkipInk: "none",
                      color: "#898989",
                    }}
                  >
                    {conversation.title || `Conversation ${index + 1}`}
                  </Typography>
                </div>
                {!isMobile && (
                  <DeleteIcon
                    sx={{
                      color: "#898989",
                      cursor: "pointer",
                      justifySelf: "flex-end",
                      ...(itemHovered != index && { display: "none" }),
                      "&:hover": {
                        color: "#ff0000",
                      },
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setOpenDeleteDialog(true);
                      setItemToDelete(conversation);
                    }}
                  />
                )}
              </ListItem>
            ))}
        </List>
      </Box>
    </Box>
  );
};

export default HistorySidebar;
